/** Panel Design System — primitive + semantic token katmanı (SSOT)
 *
 * Semantic `PANEL.*` değerleri statik HEX değil CSS değişkenleridir
 * (`var(--panel-surface)`). Light/dark boyama `data-theme` + GlobalStyles
 * ile yapılır; sx tüketicileri değişmez.
 */

import { PANEL_CSS_REF } from "./panelCssVars";

export { PANEL_PRIMITIVE } from "./panelTokens.primitives";

/** Semantic token'lar — bileşenler primitive yerine bunları kullanır */
export const PANEL = {
  pageBg: PANEL_CSS_REF.pageBg,
  /** Dark ModernDark gradient; light: none */
  pageGradient: PANEL_CSS_REF.pageGradient,
  surface: PANEL_CSS_REF.surface,
  popover: PANEL_CSS_REF.popover,
  border: PANEL_CSS_REF.border,
  text: { ...PANEL_CSS_REF.text },
  accent: {
    // Light: teal #4CCEAC. Dark: palet Primary (beyaz).
    // BRAND.teal — marketing landing; farklı kullanım alanı.
    ...PANEL_CSS_REF.accent,
  },
  blue: { ...PANEL_CSS_REF.blue },
  indigo: { ...PANEL_CSS_REF.indigo },
  danger: { ...PANEL_CSS_REF.danger },
  warning: { ...PANEL_CSS_REF.warning },
  fill: { ...PANEL_CSS_REF.fill },
  chart: { ...PANEL_CSS_REF.chart },
  radius: {
    card: "16px",
    cardSm: "14px",
    cardMd: "12px",
    chip: "8px",
    input: "10px",
    dialog: "16px",
    avatar: "12px",
  },
  drawer: {
    width: 272,
    collapsed: 76,
  },
  shadow: { ...PANEL_CSS_REF.shadow },
};

/** Rehber/adım listeleri — indigo (Model Oluştur), teal, mavi, indigo-400, amber */
export const PANEL_STEP_RANKS = [
  {
    main: PANEL.indigo.main,
    text: PANEL.indigo.text,
    soft: PANEL.indigo.soft,
    border: PANEL.indigo.softBorder,
  },
  {
    main: PANEL.accent.main,
    text: PANEL.accent.text,
    soft: PANEL.accent.soft12,
    border: PANEL.accent.softBorder22,
  },
  {
    main: PANEL.blue.main,
    text: PANEL.blue.text,
    soft: PANEL.blue.soft12,
    border: PANEL.blue.soft25,
  },
  {
    main: "var(--panel-indigo-400)",
    text: PANEL.indigo.text,
    soft: "var(--panel-indigo-soft-bg)",
    border: "var(--panel-indigo-400-border)",
  },
  {
    main: PANEL.warning.main,
    text: PANEL.warning.text,
    soft: PANEL.warning.soft,
    border: PANEL.warning.border,
  },
];

export function getPanelStepRank(index = 0) {
  const i = Number.isFinite(index) ? Math.max(0, Math.floor(index)) : 0;
  return PANEL_STEP_RANKS[i % PANEL_STEP_RANKS.length];
}

/** Light/dark aynı PANEL referansı — boyama CSS değişkenleriyle değişir */
export const PANEL_LIGHT = PANEL;
export const PANEL_DARK = PANEL;

export function getPanelTokens(/* mode = "light" */) {
  return PANEL;
}

/** Geriye uyumluluk alias'ları */
export const PANEL_PAGE_BG = PANEL.pageBg;
export const PANEL_SURFACE = PANEL.surface;
export const PANEL_BORDER = PANEL.border;
